
import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchEnterprises, fetchDomains } from "./api";

const EnterpriseContext = createContext(null);

export const useEnterprise = () => {
    const context = useContext(EnterpriseContext);
    if (!context) throw new Error("useEnterprise debe usarse dentro de <EnterpriseProvider>");
    return context;
};

export const EnterpriseProvider = ({ children }) => {
    const { id, id2 } = useParams();
    const [enterprise, setEnterprise] = useState(null);
    const [domain, setDomain] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        setLoading(true);

        Promise.all([
            id ? fetchEnterprises(id) : Promise.resolve(null),
            id && id2 && id2 !== 'new' ? fetchDomains(id, id2) : Promise.resolve(null),
        ]).then(([ent, dom]) => {
            if (!mounted) return;
            setEnterprise(ent);
            setDomain(dom);
            setLoading(false);
        });

        return () => { mounted = false; };
    }, [id, id2]);

    return (
        <EnterpriseContext.Provider value={{ enterprise, domain, loading }}>
            {children}
        </EnterpriseContext.Provider>
    );
};
